import { atom } from 'recoil';

import { DEFAULT_CONFIRM_MODAL_STATE } from './defaults';

export const confirmModalState = atom({
  key: 'confirmModalState',
  default: DEFAULT_CONFIRM_MODAL_STATE,
});
